import React from "react";
import HeroSection from "../components/HeroSection";
import { Link } from "react-router-dom";
import icons from "../constants/icons.ts";
import { heroSections } from "../constants/data.ts";

const About = () => {
  const teamMembers = [
    { name: "Team Member 1", role: "Founder & CEO" },
    { name: "Team Member 2", role: "CTO" },
    { name: "Team Member 3", role: "Lead Developer" },
    { name: "Team Member 4", role: "Design Lead" },
  ];

  return (
    <main className="bg-background">
      {/* Hero Section */}
      <HeroSection {...heroSections.about} />

      {/* Company Overview */}
      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto max-w-3xl">
          <h2 className="heading-main text-center mb-8">Our Story</h2>
          <p className="text-body mb-6 text-center">
            Westlisoft is a forward-thinking technology company dedicated to
            delivering innovative solutions that transform businesses. Founded
            with a vision to bridge the gap between technology and business
            needs, we've grown into a trusted partner for organizations across
            various industries.
          </p>
          <p className="text-body mb-6 text-center">
            Our commitment to excellence, customer satisfaction, and continuous
            innovation has enabled us to deliver over 50 successful projects to
            clients worldwide.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16 md:py-24 px-outer bg-white">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Mission */}
            <div className="text-center">
              <i className={`${icons.about.mission} text-5xl text-primary mb-4`}></i>
              <h3 className="heading mb-4">Our Mission</h3>
              <p className="text-body">
                To empower businesses through innovative technology solutions
                that drive growth, efficiency, and success in an increasingly
                digital world.
              </p>
            </div>

            {/* Vision */}
            <div className="text-center">
              <i className={`${icons.about.vision} text-5xl text-primary mb-4`}></i>
              <h3 className="heading mb-4">Our Vision</h3>
              <p className="text-body">
                To be the most trusted technology partner for organizations
                seeking transformational solutions that create lasting impact
                and value.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto max-w-4xl">
          <h2 className="heading-main text-center mb-12">Our Core Values</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="card">
              <i className={`${icons.about.integrity} text-3xl text-primary mb-4`}></i>
              <h3 className="heading mb-3">Integrity</h3>
              <p className="text-body">
                We believe in honesty and transparency in all our dealings with
                clients and partners.
              </p>
            </div>

            <div className="card">
              <i className={`${icons.about.innovation} text-3xl text-primary mb-4`}></i>
              <h3 className="heading mb-3">Innovation</h3>
              <p className="text-body">
                Continuous improvement and adoption of cutting-edge technologies
                drive our solutions.
              </p>
            </div>

            <div className="card">
              <i className={`${icons.about.collaboration} text-3xl text-primary mb-4`}></i>
              <h3 className="heading mb-3">Collaboration</h3>
              <p className="text-body">
                We work closely with our clients as partners to understand and
                exceed their expectations.
              </p>
            </div>

            <div className="card">
              <i className={`${icons.about.excellence} text-3xl text-primary mb-4`}></i>
              <h3 className="heading mb-3">Excellence</h3>
              <p className="text-body">
                We strive for the highest quality in everything we do, from code
                to customer service.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 md:py-24 px-outer bg-white">
        <div className="container mx-auto">
          <h2 className="heading-main text-center mb-12">Our Team</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {teamMembers.map((member, index) => (
              <div key={index} className="text-center">
                <div className="bg-gradient-to-b from-primary to-secondary h-48 rounded-card mb-4 flex items-center justify-center">
                  <i className={`${icons.about.teamMember} text-6xl text-white opacity-20`}></i>
                </div>
                <h3 className="font-rubik font-bold text-secondary">
                  {member.name}
                </h3>
                <p className="text-body text-sm">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto max-w-3xl">
          <h2 className="heading-main text-center mb-12">
            Why Choose Westlisoft?
          </h2>

          <div className="space-y-6">
            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Proven Experience</h3>
                <p className="text-body">
                  Over 4 years of experience delivering solutions to clients
                  across diverse industries.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Skilled Team</h3>
                <p className="text-body">
                  A team of certified professionals with expertise in latest
                  technologies and methodologies.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Client-Centric Approach</h3>
                <p className="text-body">
                  Your success is our success. We prioritize understanding and
                  exceeding your needs.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Quality Assurance</h3>
                <p className="text-body">
                  Rigorous testing and quality control ensure reliable, robust
                  solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 px-outer bg-gradient-to-r from-secondary to-blue-900">
        <div className="container mx-auto text-center text-white">
          <h2 className="font-rubik font-bold text-3xl md:text-4xl mb-4">
            Let's Work Together
          </h2>
          <p className="font-rubik font-light text-lg mb-8 max-w-2xl mx-auto">
            Ready to partner with us? Let's discuss how we can help transform
            your business.
          </p>
          <Link to="/contact" className="btn-primary">
              Contact Us
          </Link>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 md:py-24 px-outer bg-white">
        <div className="container mx-auto max-w-3xl">
          <h2 className="heading-main text-center mb-12">
            Frequently Asked Questions
          </h2>

          <div className="space-y-4">
            <details className="card group cursor-pointer">
              <summary className="flex items-center justify-between font-rubik font-bold text-secondary">
                What is your typical response time?
                <i className={`${icons.actions.chevronDown} group-open:rotate-180 transition-transform`}></i>
              </summary>
              <p className="text-body text-sm mt-4">
                We typically respond to inquiries within 24 hours during
                business days.
              </p>
            </details>

            <details className="card group cursor-pointer">
              <summary className="flex items-center justify-between font-rubik font-bold text-secondary">
                Do you provide ongoing support?
                <i className={`${icons.actions.chevronDown} group-open:rotate-180 transition-transform`}></i>
              </summary>
              <p className="text-body text-sm mt-4">
                Yes, we offer comprehensive support packages tailored to your
                needs.
              </p>
            </details>

            <details className="card group cursor-pointer">
              <summary className="flex items-center justify-between font-rubik font-bold text-secondary">
                What's your project timeline?
                <i className={`${icons.actions.chevronDown} group-open:rotate-180 transition-transform`}></i>
              </summary>
              <p className="text-body text-sm mt-4">
                Timelines vary based on project scope. We provide detailed
                estimates during consultation.
              </p>
            </details>
          </div>
        </div>
      </section>

      {/* Industry Focus */}
      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto max-w-3xl">
          <h2 className="heading-main text-center mb-8">
            Specialized Expertise
          </h2>

          <div className="space-y-6">
            <div className="flex gap-4">
              <i className={`${icons.about.domainKnowledge} text-primary text-2xl mt-1 flex-shrink-0`}></i>
              <div>
                <h3 className="heading mb-2">Domain Knowledge</h3>
                <p className="text-body">
                  Deep understanding of industry-specific challenges and
                  regulations.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.about.bestPractices} text-primary text-2xl mt-1 flex-shrink-0`}></i>
              <div>
                <h3 className="heading mb-2">Best Practices</h3>
                <p className="text-body">
                  Implementation of industry standards and compliance
                  requirements.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.about.roi} text-primary text-2xl mt-1 flex-shrink-0`}></i>
              <div>
                <h3 className="heading mb-2">ROI Focused</h3>
                <p className="text-body">
                  Solutions designed to maximize your return on investment and
                  efficiency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Details Section */}
      <section className="py-16 md:py-24 px-outer bg-white">
        <div className="container mx-auto">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-main text-center mb-8">
              Why Choose Our Services?
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex gap-4">
                <i className={`${icons.actions.checkCircle} text-primary text-2xl mt-1 flex-shrink-0`}></i>
                <div>
                  <h3 className="heading mb-2">Expert Team</h3>
                  <p className="text-body">
                    Our experienced professionals have worked with clients
                    across various industries.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <i className={`${icons.actions.checkCircle} text-primary text-2xl mt-1 flex-shrink-0`}></i>
                <div>
                  <h3 className="heading mb-2">Proven Track Record</h3>
                  <p className="text-body">
                    Hundreds of successful projects delivered on time and within
                    budget.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <i className={`${icons.actions.checkCircle} text-primary text-2xl mt-1 flex-shrink-0`}></i>
                <div>
                  <h3 className="heading mb-2">Latest Technology</h3>
                  <p className="text-body">
                    We use cutting-edge technologies and best practices in our
                    solutions.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <i className={`${icons.actions.checkCircle} text-primary text-2xl mt-1 flex-shrink-0`}></i>
                <div>
                  <h3 className="heading mb-2">Dedicated Support</h3>
                  <p className="text-body">
                    Ongoing support and maintenance to ensure your success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
};

export default About;
